import {
  CustomButton,
  CustomCollapseCard,
  CustomTable,
  Text,
  successDialog,
} from '@src/components';
import React, { useCallback, useEffect } from 'react';
import '@src/styles/pendingApproval/balanceOrder.scss';
import { useDispatch, useSelector } from 'react-redux';
import {
  cardGetPagedList,
  mobileUpdatePaymentsCollective,
  clearList,
} from '@src/store/slice/manageMyCardsSlice';
import { Button } from 'antd';
import {
  setSelecteAutoUploadDetails,
  setIsAllSelectedRowKeys,
  setAutoLoadingNotIncludedCards,
  setSelectedRowKeys,
} from '@src/store/slice/autoUploadInstructionsSlice';
import { getPendingNotifications } from '@src/store/slice/notificationSlice';

const MobilePaymentPermision = () => {
  const dispatch = useDispatch();
  const { list } = useSelector((state) => state?.manageMyCards);
  const { processType } = useSelector((state) => state?.packages);
  const { detailList, selectedRowKeys, selectedAutoUploadDetails, isAllSelectedRowKeys } = useSelector((state) => state?.autoUploadInstructions);
  const { menus } = useSelector((state) => state?.menus);
  useEffect(() => {
    if ([0, 1, 6, 8].includes(processType)) loadCardOrders();
  }, []);
  const loadCardOrders = useCallback(async () => {
    dispatch(clearList());

    const validMenuIds = [11, 94, 1];

    const activeMenuIds = menus
      ?.map((menu) => menu?.vouId)
      .filter((id) => validMenuIds.includes(id));

    if (activeMenuIds && activeMenuIds.length > 0) {
      for (let i = 0; i < activeMenuIds.length; i++) {
        const vouId = activeMenuIds[i];

        await dispatch(
          cardGetPagedList({
            body: { pageSize: 99999, hasNoMobilePayment: true, vouId },
            ...(i > 0 && { append: true }),
          })
        );
      }
    }
  }, [dispatch]);
  const handleMobileUpdatePayments = async (record) => {
    const body = {
      vouId: 1,
      hasMobilePayment: true,
      customerId: record.customerId,
      usrList: [record.mobileAppUserId],
    };
    const action = await dispatch(
      mobileUpdatePaymentsCollective({ mobilePaymentCollectiveRequestDto: body }),
    );
    clearForm(action);
  };
  const handleAllMobileUpdatePayments = async () => {
    const usrList = [];
    (isAllSelectedRowKeys ? list : selectedAutoUploadDetails).map((selected) =>
      usrList.push(selected.mobileAppUserId),
    );
    const body = {
      vouId: 1,
      hasMobilePayment: true,
      customerId: selectedAutoUploadDetails?.[0]?.customerId,
      usrList,
    };
    const action = await dispatch(
      mobileUpdatePaymentsCollective({ mobilePaymentCollectiveRequestDto: body }),
    );
    clearForm(action);
  };
  const clearForm = (action) => {
    if (mobileUpdatePaymentsCollective.fulfilled.match(action)) {
      successDialog({
        title: <Text t="successfullySent" />,
        message: action?.payload?.message || <Text t="successfullySent" />,
        onOk: async () => {
          dispatch(setSelectedRowKeys([]));
          dispatch(setSelecteAutoUploadDetails([]));
          dispatch(setIsAllSelectedRowKeys([]));
          dispatch(cardGetPagedList({ body: { pageSize: 9999, hasNoMobilePayment: true } }));
          dispatch(getPendingNotifications({}));
        },
      });
    }
  };
  const onGridSelectChange = (record, data) => {
    dispatch(setSelectedRowKeys(record));
    dispatch(setSelecteAutoUploadDetails(data));
  };
  const columnsCard = [
    {
      title: <Text t="cardNumber4" />,
      dataIndex: 'cardNumber',
      key: 'cardNumber',
      width: '20%',
      responsive: ['md'],
    },
    {
      title: <Text t="referenceCode3" />,
      dataIndex: 'refNo',
      key: 'refNo',
      width: '20%',
      responsive: ['md'],
    },
    {
      title: <Text t="nameUpperCase" />,
      dataIndex: 'name',
      key: 'name',
      width: '20%',
      responsive: ['md'],
    },
    {
      title: <Text t="surnameUpperCase" />,
      dataIndex: 'surname',
      key: 'surname',
      width: '20%',
      responsive: ['md'],
    },
    {
      title: <Text t="gsmNoUpperCase" />,
      dataIndex: 'gsm',
      key: 'gsm',
      width: '20%',
      responsive: ['md'],
    },
    {
      title: '',
      dataIndex: 'hasMobilePayment',
      key: 'hasMobilePayment',
      align: 'center',
      responsive: ['md'],
      render: (_, record) => {
        return (
          <div className="row-btn-actions">
            <CustomButton
              id="pendingApproval-cardOrderList-custom-second-btn-approved"
              onClick={() => handleMobileUpdatePayments(record)}
              className="custom-btn-approved custom-btn-approved-huge"
            //buttonAuthName="ApprovalAuthorizationGroup"
            >
              <Text t="mobilePaymentApproval" />
            </CustomButton>
          </div>
        );
      },
    },
  ];
  return (
    <CustomCollapseCard
      className="card-order-card"
      cardTitle={<Text t="mobilePaymentPermissionApproval" />}
    >
      <CustomTable
        rowSelection={{
          preserveSelectedRowKeys: true,
          type: 'checkbox',
          selectedRowKeys,
          onChange: (selectedRowKeys, selectedRows) => {
            onGridSelectChange(selectedRowKeys, selectedRows);
            const deselectedRows = detailList.filter(
              (row) => !selectedRowKeys.includes(`list-${row?.cardNumber}`),
            );
            dispatch(setAutoLoadingNotIncludedCards(deselectedRows));
          },
          onSelectAll: async (selected) => {
            await dispatch(setIsAllSelectedRowKeys(selected));
          },
        }}
        pagination={true}
        isScroll={false}
        dataSource={list}
        columns={columnsCard}
        rowKey={(record) => `list-${record?.id}`}
      />
      <Button
        style={
          selectedAutoUploadDetails?.length < 1
            ? {
              marginLeft: '24px',
              bottom: '40px',
              color: '#ffffff',
              background: '#d8d8d8',
              border: 'none',
            }
            : { marginLeft: '24px', bottom: '40px', background: '#00a483' }
        }
        className={'table-row-add-btn'}
        onClick={handleAllMobileUpdatePayments}
        disabled={selectedAutoUploadDetails?.length < 1}
      >
        <Text t="giveBulkMobilePaymentApprovalToSelectedCards" />
      </Button>
    </CustomCollapseCard>
  );
};

export default MobilePaymentPermision;
